import { SET_LN_CONTENT } from './LNActions';
import { PRACTICE, QUESTIONS } from '../constants/assessmentItemType';

const contentDefaultState = {
    isDataFetched: false,
    formId: undefined,
    [PRACTICE]: [],
    [QUESTIONS]: [],
};

export const defaultState = {
    ...contentDefaultState,
    isButtonGridEnabled: true,
    enabledResponses: undefined,
};

const mapContent = (question) => ({
    ...(question.item_id && { itemId: question.item_id }),
    ...(question.correct_response && { correctResponse: question.correct_response }),
    stimulus: {
        audio: question.stimulus.stimulus_audio,
    },
});

const reformatLNContent = (apiContent) => ({
    assessment: apiContent.assessment,
    measure: apiContent.measure,
    formId: apiContent.form_id,
    practice: apiContent.practice.map(mapContent),
    questions: apiContent.questions.map(mapContent),
});

const lnReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SET_LN_CONTENT:
        return {
            ...state,
            isDataFetched: true,
            ...reformatLNContent(action.content),
        };
    default:
        return state;
    }
};

export default lnReducer;
